import * as service from "./SummerNote.service.js";

export default {
  // props: [
  //     'editorHeight',
  //     'editorData',
  //     'role',
  //     'model',
  //     'reportStatus',
  //     'isDisabled',
  // ],

  props: {
    editorData: {
      type: Object,
      default: () => {
        return {};
      },
    },
    editorHeight: {
      type: Number,
      default: null,
    },
    tabName: {
      type: String,
      default: "",
    },
    role: {
      type: String,
      required: true,
    },
    model: {
      type: String,
      default: "",
    },
    reportStatus: {
      type: String,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      summerNoteId: "",
      imgArr: [],
      oldValue: "",
      popover: {
        image: [
          [
            "image",
            ["resizeFull", "resizeHalf", "resizeQuarter", "resizeNone"],
          ],
          ["float", ["floatLeft", "floatRight", "floatNone"]],
          ["remove", ["removeMedia"]],
        ],
      },
      disableResizeImage: false,
    };
  },

  mounted() {
    this.summerNoteId = this.tabName;
    let context = this;
    let height = this.editorHeight;
    let isDrag = true;

    if (context.isDisabled) {
      context.popover = { image: [] };
      context.disableResizeImage = true;
    }
    this.initSummerNote(height, isDrag);

    this.$router.app.$on("updateContentSummerNote", this.reMountComponent);
    this.$router.app.$on("initSummerNote", this.initSummerNote);
  },

  methods: {
    reMountComponent(tabName, content) {
      let context = this;
      if (this.tabName == tabName) {
        var elementId = document.getElementById(context.tabName);
        $(elementId).summernote("code", content);
      }
    },
    initSummerNote(height, isDrag) {
      let vm = this;
      let context = this;

      $(this.$el).summernote({
        addclass: {
          debug: false,

          classTags: [
            { title: "Button", value: "btn btn-success" },
            "jumbotron",
            "lead",
            "img-rounded",
            "img-circle",
            "img-responsive",
            "btn",
            "btn btn-success",
            "btn btn-danger",
            "text-muted",
            "text-primary",
            "text-warning",
            "text-danger",
            "text-success",
            "table-bordered",
            "table-responsive",
            "alert",
            "alert alert-success",
            "alert alert-info",
            "alert alert-warning",
            "alert alert-danger",
            "visible-sm",
            "hidden-xs",
            "hidden-md",
            "hidden-lg",
            "hidden-print",
          ],
        },
        disableResizeEditor: true,
        disableDragAndDrop: isDrag,
        height: height,
        popover: context.popover,
        disableResizeImage: context.disableResizeImage,
        toolbar: [
          ["img", ["picture"]],
          ["style", ["bold", "italic", "underline", "clear"]],
          ["font", ["strikethrough", "superscript", "subscript"]],
          ["fontsize", ["fontsize"]],
          ["color", ["color"]],
          ["extra", ["table"]],
          ["para", ["ul", "ol", "link", "paragraph"]],
          ["misc", ["undo", "redo"]],
        ],
        callbacks: {
          onInit: function() {
            $(vm.$el).summernote("code", vm.model);
            service.SetTotalImageCount(0);
            service.SetUploadedImageCount(0);
          },
          onChange: function() {
            vm.$emit("update:model", $(vm.$el).summernote("code"));
          },
          onPaste: function(e) {
            debugger;

            var clipboardData = e.originalEvent.clipboardData;
            if (
              clipboardData &&
              clipboardData.items &&
              clipboardData.items.length
            ) {
              var item = clipboardData.items[0];
              if (item.kind === "file" && item.type.indexOf("image/") !== -1) {
                e.preventDefault();
              }
            }
          },
          onImageUpload: function(image) {
            debugger;
            var sizeKB = image[0]["size"] / 1000;
            var tmp_pr = 0;
            if (sizeKB > 3000) {
              tmp_pr = 1;
              const data = {
                color: "warning",
                text: "Image size must be < 3Mb.",
              };
              context.$router.app.$emit("snackbarTrigger", data);
            }
            if (
              image[0]["type"] != "image/jpeg" &&
              image[0]["type"] != "image/png" &&
              image[0]["type"] != "image/gif"
            ) {
              tmp_pr = 1;
              const data = {
                color: "warning",
                text: "Image type must be jpg/png/gif .",
              };
              context.$router.app.$emit("snackbarTrigger", data);
            }
            if (tmp_pr == 0) {
              service.SetTotalImageCount(1);
              var imgUrl = URL.createObjectURL(image[0]);

              var imgBlob = imgUrl.substr(imgUrl.lastIndexOf("/") + 1);
              var imgId = image[0].name;
              context.imgArr.push({
                imageName: imgId,
                imageBlob: imgBlob,
                fileDat: image[0],
              });
              $(this).summernote("insertImage", imgUrl, imgBlob);
            }
          },
          onMediaDelete: function(target) {
            let TotalImageCount = service.GetTotalImageCount();
            if (TotalImageCount > 0) {
              service.SetTotalImageCount(-1);
            }
          },
          onFocus: function() {
            this.oldValue = $(this).summernote("code");
          },
          onKeyup: function(e) {
            if (e.keyCode == 8 || e.keyCode == 46) {
              let newValue = e.target.innerHTML;
              let newImage = newValue.match(/<img\s(?:.+?)>/g);
              let oldImages = this.oldValue.match(/<img\s(?:.+?)>/g);
              let newImageCount = 0,
                oldImagesCount = 0;
              if (oldImages != null) {
                newImageCount = newImage ? newImage.length : 0;
                oldImagesCount = oldImages ? oldImages.length : 0;
                let countDiff =
                  parseInt(oldImagesCount) - parseInt(newImageCount);
                let TotalImageCount = service.GetTotalImageCount();
                if (TotalImageCount > 0) {
                  service.SetTotalImageCount(-countDiff);
                }
              }
            }
          },
        },
      });

      // Disable Summernote based on prop 'IsDisabled' value
      this.$nextTick(() => {
        if (context.isDisabled) {
          var elementId = document.getElementById(context.tabName);
          $(elementId).summernote("disable");

          elementId.parentElement.getElementsByClassName(
            "note-toolbar panel-heading"
          )[0].style.display = "none";
        }
      });
    },

    saveImage(status, submittedBy, action) {
      let context = this;
      Promise.all(
        this.imgArr.map(function(item) {
          service.UploadImage(item.fileDat).then(
            (fileData) => {
              fileData.ref
                .getDownloadURL()
                .then((downloadURL) => {
                  service.SetUploadedImageCount(1);
                  $("[data-filename=" + item.imageBlob + "]").attr(
                    "src",
                    downloadURL
                  );
                })
                .then(() => {
                  let UploadedImageCount = service.GetUploadedImageCount();
                  let TotalImageCount = service.GetTotalImageCount();
                  if (UploadedImageCount == TotalImageCount) {
                    service.SetTotalImageCount(0);
                    service.SetUploadedImageCount(0);
                    context.$router.app.$emit(
                      "saveContentTrigger",
                      status,
                      submittedBy,
                      action
                    );
                  }
                });
            },
            (error) => {}
          );
        })
      );
    },
  },

  watch: {
    editorData: function(newValue, old) {
      let height = this.editorHeight;
      let isDrag = true;
      if (
        this.role == "Manager" &&
        this.tabName != "Response" &&
        this.reportStatus == "Working"
      ) {
        isDrag = false;
      } else if (
        this.role == "Leader" &&
        this.tabName == "Response" &&
        this.reportStatus != "Accepted"
      ) {
        isDrag = false;
      } else if (this.role == "Admin" && this.reportStatus != "Accepted") {
        isDrag = false;
      }
      $(this.$el).summernote("destroy");
      this.initSummerNote(height, isDrag);
    },
    model: function(newValue, old) {
      var el = this.$el;
      $(el).summernote("code", newValue);
    },
  },

  beforeDestroy() {
    this.$router.app.$off("updateContentSummerNote");
    this.$router.app.$off("initSummerNote");
  },
};
